import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadServer = () => {
    const promiseServer = new Promise((resolve, reject) => {
        loader.load(
            "office/model/server/server.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                // Posizione iniziale da regolare
                model.position.set(3.9204949110981255, 0.5327961927370954, 4.2);
                model.scale.set(0.45, 0.45, 0.45);
                model.rotation.set(3.141592653589793, -1.5638163735862718, 3.141592653589793);




                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                // Abilitiamo il ControlFunction per posizionarlo con il mouse
                //ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseServer;
};

export { loadServer };
